module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/close@2x-69ee9857b2819591ce26d4cd6526e965.png";